module.exports = __webpack_public_path__ + "static/media/ic-folder-move.a419ebd3.svg";